import { Button } from '../../shadcn';
import Logo from '@/assets/logo-horizontal.svg';

export const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="relative h-screen w-screen flex flex-col items-center justify-center gap-4 px-5 bg-background overflow-hidden">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-gradient-brand opacity-10 blur-3xl" />
      <img src={Logo} alt="PixelPlay" className="relative z-10 w-60 h-30" />
      <div className="relative z-10 flex flex-col gap-3">
        <h2 className="font-display text-foreground text-[28px] font-bold leading-tight text-center">
          Oops! Something went wrong.
        </h2>
        <p className="text-muted-foreground text-base font-normal leading-normal text-center">
          {error.message}
        </p>
      </div>
      <Button
        size="lg"
        variant="gradient"
        className="relative z-10 mt-5"
        onClick={resetErrorBoundary}
      >
        Try Again
      </Button>
    </div>
  );
};
